var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { partnerCertificationMapper } from "./../../../../domains/salesFeatures/Partner360/mappers/PartnerCertificationMapper";
import { partnerRegistrationDetailsMapper } from "./../../../../domains/salesFeatures/Partner360/mappers/PartnerRegistrationDetailsMapper";
import partnerOverViewUrlConfig from "@adapters/infrastructures/urlConfig/SalesJourney/Partner360/PartnerURL";
import { partnerProfDemMetNomSegMapper } from "@domains/salesFeatures/Partner360/mappers/PartnerProfileDemMetNomSegMapper";
import { partnerBankDetailsMapper } from "@domains/salesFeatures/Partner360/mappers/PartnerBankDetailsMapper";
import { partnerAccountCodesMapper } from "@domains/salesFeatures/Partner360/mappers/IPartnerAccountCodesMapper";
import { partnerClientsSummaryMapper } from "@domains/salesFeatures/Partner360/mappers/PartnerClientsSummaryMapper";
var PartnerOverviewRepository = /** @class */ (function () {
    function PartnerOverviewRepository(http) {
        this.http = http;
    }
    PartnerOverviewRepository.prototype.getPartnerRevenueSummary = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, partnerRevenueSummaryData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(partnerOverViewUrlConfig.partnerRevenueSummary);
                        url.searchParams.append("AcCode", req.accountCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        partnerRevenueSummaryData = _a.sent();
                        return [2 /*return*/, {
                                partnerRevenueSummary: partnerRevenueSummaryData === null || partnerRevenueSummaryData === void 0 ? void 0 : partnerRevenueSummaryData.data,
                            }];
                }
            });
        });
    };
    PartnerOverviewRepository.prototype.getPartnerClientsSummary = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, partnerClientsSummaryData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(partnerOverViewUrlConfig.partnerClientsSummary);
                        url.searchParams.append("AcCode", req.accountCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        partnerClientsSummaryData = _a.sent();
                        return [2 /*return*/, partnerClientsSummaryMapper(partnerClientsSummaryData.data)];
                }
            });
        });
    };
    PartnerOverviewRepository.prototype.getPartnerAccountCodes = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, partnerSearchData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(partnerOverViewUrlConfig.partnerSearch);
                        if (req.AcCode !== undefined && req.AcCode !== null && req.AcCode !== "") {
                            url.searchParams.append("AcCode", req.AcCode);
                        }
                        if (req.upcId !== undefined && req.upcId !== null && req.upcId !== "") {
                            url.searchParams.append("UpcId", req.upcId);
                        }
                        url.searchParams.append("page", req.page.toString());
                        url.searchParams.append("pageSize", req.pageSize.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        partnerSearchData = _a.sent();
                        return [2 /*return*/, partnerAccountCodesMapper(partnerSearchData)];
                }
            });
        });
    };
    PartnerOverviewRepository.prototype.getPartnerProfDemoMapNomSegDetails = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, partnerData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(partnerOverViewUrlConfig.profDemoMapNomSegDetails);
                        url.searchParams.append("AcCode", req.AcCode);
                        if (req.flg !== undefined &&
                            req.flg !== null &&
                            req.flg !== "" &&
                            req.flg &&
                            ((_a = req.flg) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            url.searchParams.append("flg", req.flg);
                        }
                        url.searchParams.append("page", req.page.toString());
                        url.searchParams.append("pageSize", req.pageSize.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        partnerData = _b.sent();
                        return [2 /*return*/, partnerProfDemMetNomSegMapper(partnerData)];
                }
            });
        });
    };
    PartnerOverviewRepository.prototype.getPartnerBankDetails = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, bankData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(partnerOverViewUrlConfig.bank);
                        url.searchParams.append("AcCode", req.AcCode);
                        if (req.flg !== undefined &&
                            req.flg !== null &&
                            req.flg !== "" &&
                            req.flg &&
                            ((_a = req.flg) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            url.searchParams.append("flg", req.flg);
                        }
                        url.searchParams.append("page", req.page.toString());
                        url.searchParams.append("pageSize", req.pageSize.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        bankData = _b.sent();
                        return [2 /*return*/, partnerBankDetailsMapper(bankData)];
                }
            });
        });
    };
    PartnerOverviewRepository.prototype.getPartnerRegistrationDetails = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, regData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(partnerOverViewUrlConfig.registrationDetails);
                        url.searchParams.append("AcCode", req.AcCode);
                        if (req.flg !== undefined &&
                            req.flg !== null &&
                            req.flg !== "" &&
                            req.flg &&
                            ((_a = req.flg) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            url.searchParams.append("flg", req.flg);
                        }
                        url.searchParams.append("page", req.page.toString());
                        url.searchParams.append("pageSize", req.pageSize.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        regData = _b.sent();
                        return [2 /*return*/, partnerRegistrationDetailsMapper(regData)];
                }
            });
        });
    };
    PartnerOverviewRepository.prototype.getPartnerCertificationDetails = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, certData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(partnerOverViewUrlConfig.certificationDetails);
                        url.searchParams.append("AcCode", req.AcCode);
                        if (req.flg !== undefined &&
                            req.flg !== null &&
                            req.flg !== "" &&
                            req.flg &&
                            ((_a = req.flg) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            url.searchParams.append("flg", req.flg);
                        }
                        url.searchParams.append("page", req.page.toString());
                        url.searchParams.append("pageSize", req.pageSize.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        certData = _b.sent();
                        return [2 /*return*/, partnerCertificationMapper(certData)];
                }
            });
        });
    };
    return PartnerOverviewRepository;
}());
export default PartnerOverviewRepository;
